// --- React
import React from "react";
// --- External UI Libraries
import { Drawer } from "antd";
import Checkbox from "@dtci/spellbook/Checkbox";
// --- Styles
import "./styles.scss";

/**
 * Columns Drawer Component
 *
 * Allows users to show/hide columns in the Offer History grid.
 */
export function ColumnsDrawer({
  open,
  onClose,
  columnOptions,
  hiddenColumns,
  onToggleColumn,
}) {
  return (
    <Drawer
      title="Columns"
      placement="right"
      width={320}
      onClose={onClose}
      open={open}
      className="offer-history-drawer"
    >
      <div className="drawer-columns-content">
        {columnOptions?.map((col) => (
          <Checkbox
            key={col.field}
            className="drawer-column-checkbox"
            option={{
              id: col.field,
              name: col.field,
              label: col.label,
            }}
            checked={!hiddenColumns?.includes(col.field)}
            onChange={() => onToggleColumn(col.field)}
          />
        ))}
      </div>
    </Drawer>
  );
}
